import { useMemo } from 'react';
import { DemeterCommodity } from '../../../../../../Generated/Raven-Demeter';
import Dropdown from '../../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../../Services/Language/useLanguageHook';
import { LiquidityRiskCalculationInputs } from '../../../RiskDefinitions';

interface ILiquidityRiskCommodityDropdownProps {
    calculationInputs: LiquidityRiskCalculationInputs;
    setCalculatorInputs: (value: LiquidityRiskCalculationInputs) => void;
}

const LiquidityRiskCommodityDropdown: React.FC<ILiquidityRiskCommodityDropdownProps> = (props: ILiquidityRiskCommodityDropdownProps) => {
    const [translations] = useLanguage();

    const commodityOptions = useMemo(
        () => [
            {
                label: translations.commodity[DemeterCommodity.CattleFeeder],
                value: DemeterCommodity.CattleFeeder,
            },
            {
                // Requested name change to match Hudson for this dropdown.  Ticket 136244
                label: translations.risk.insuranceQuoteEstimator.commodity.fedCattleType,
                value: DemeterCommodity.CattleLive,
            },
            {
                label: translations.commodity[DemeterCommodity.LeanHog],
                value: DemeterCommodity.LeanHog,
            },
        ],
        [translations],
    );

    return (
        <Dropdown
            value={props.calculationInputs.commodity}
            options={commodityOptions}
            handleOptionChange={(value) => props.setCalculatorInputs({ ...props.calculationInputs, commodity: value as DemeterCommodity })}
            label={translations.words.commodity}
            track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'LivestockCommodityChanged' }}
        />
    );
};

export default LiquidityRiskCommodityDropdown;
